module.exports = __webpack_public_path__ + "static/media/goals-and-targets-gross-margins.b17365e4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-gross-margins.mp4
// module id = 559
// module chunks = 0